/* Cash Money: predictive search fix. Shopify /search/suggest returns 417 (Unsupported buyer locale) for Arabic, so results come from /search instead.
   + Zero-price products (price on request) in the custom rows (.cmpx / .cmrw) show "السعر عند الطلب" instead of "0 ج.م". */
(function () {
if (window.__cmSearchFix) return;
window.__cmSearchFix = true;
var WS = new RegExp('[' + String.fromCharCode(9, 10, 13, 32, 160) + ']+', 'g');
function askPrice() {
  document.querySelectorAll('.cmpx__price em, .cmrw__price em').forEach(function (e) {
    var t = e.textContent.replace(WS, '');
    if (t === '0ج.م' || t === '0.00ج.م' || t === '0,00ج.م' || t === 'E£0' || t === '0EGP') e.textContent = 'السعر عند الطلب';
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', askPrice); else askPrice();
var css = document.createElement('style');
css.textContent = '.cm-ps{padding:12px 16px;direction:rtl;width:100%;flex:1 1 100%;grid-column:1/-1;box-sizing:border-box}.cm-ps__h{font-size:13px;color:#6b7280;margin:4px 0 10px}.cm-ps ul{list-style:none;margin:0;padding:0;display:grid;gap:6px;width:100%}@media(min-width:750px){.cm-ps ul{grid-template-columns:1fr 1fr}}.cm-ps li.predictive-search-results__card{width:100%;max-width:none;border:1px solid #ecebe6;border-radius:12px;padding:0;margin:0}.cm-ps li a{display:flex;align-items:center;gap:12px;padding:8px;border-radius:10px;text-decoration:none;color:inherit}.cm-ps li a:hover,.cm-ps li[aria-selected=true] a{background:rgba(0,0,0,.05)}.cm-ps img{width:56px;height:56px;object-fit:contain;background:#fff;border-radius:8px;flex:0 0 56px}.cm-ps__t{font-size:14px;font-weight:600;line-height:1.4}.cm-ps__p{font-size:13px;color:#1f5d36;font-weight:700;margin-top:2px}.cm-ps__all{display:block;text-align:center;margin-top:12px;padding:10px;border-radius:10px;background:#1f5d36;color:#fff!important;font-weight:700;text-decoration:none}.cm-ps__none{padding:16px;text-align:center;color:#6b7280}';
document.head.appendChild(css);
function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
var cache = {};
function fetchResults(term) {
if (cache[term]) return Promise.resolve(cache[term]);
return fetch('/search?type=product&q=' + encodeURIComponent(term), { credentials: 'same-origin' })
.then(function (r) { return r.text(); })
.then(function (html) {
var doc = new DOMParser().parseFromString(html, 'text/html');
var seen = {}; var items = [];
doc.querySelectorAll('product-card').forEach(function (card) {
var a = card.querySelector('a.product-card__link') || card.querySelector('a[href*="/products/"]');
if (!a) return;
var href = a.getAttribute('href').split('?')[0];
if (seen[href]) return; seen[href] = 1;
var t = (a.querySelector('.visually-hidden') || a).textContent.replace(WS, ' ').trim();
var img = card.querySelector('img');
var src = img ? (img.getAttribute('src') || '') : '';
var pr = card.querySelector('[class*="price"]');
var price = pr ? pr.textContent.replace(WS, ' ').trim() : '';
items.push({ href: href, t: t, src: src, price: price });
});
cache[term] = items;
return items;
});
}
function render(box, term, items) {
var all = '/search?type=product&q=' + encodeURIComponent(term);
if (!items.length) { box.innerHTML = '<div class="cm-ps"><div class="cm-ps__none">مفيش نتايج لـ «' + esc(term) + '»</div></div>'; return; }
var html = '<div class="cm-ps"><div class="cm-ps__h">المنتجات</div><ul>';
items.slice(0, 8).forEach(function (it) {
html += '<li ref="resultsItems[]" class="predictive-search-results__card"><a href="' + esc(it.href) + '">' + (it.src ? '<img src="' + esc(it.src) + '" alt="" loading="lazy">' : '') + '<span><span class="cm-ps__t">' + esc(it.t) + '</span>' + (it.price ? '<span class="cm-ps__p" style="display:block">' + esc(it.price) + '</span>' : '') + '</span></a></li>';
});
html += '</ul><a class="cm-ps__all" href="' + all + '">اعرض كل النتائج' + (items.length > 8 ? ' (' + items.length + '+)' : '') + '</a></div>';
box.innerHTML = html;
}
document.addEventListener('input', function (e) {
var inp = e.target;
if (!(inp instanceof HTMLInputElement)) return;
var comp = inp.closest('predictive-search-component');
if (!comp) return;
var term = inp.value.trim();
clearTimeout(comp.__cmT);
if (!term) return;
comp.__cmT = setTimeout(function () {
var my = (comp.__cmSeq = (comp.__cmSeq || 0) + 1);
fetchResults(term).then(function (items) {
if (my !== comp.__cmSeq || inp.value.trim() !== term) return;
var box = comp.querySelector('[ref="predictiveSearchResults"]');
if (box) render(box, term, items);
}).catch(function () {});
}, 300);
}, true);
})();